module.exports = __webpack_public_path__ + "static/carrot-joe-teaser-2541556d575da84254b8ae4cc84ac3e5.jpg";